import { useEffect } from 'react';
export var useOutsideClick = function (ref, callback) {
    var handleClick = function (event) {
        if (ref.current && !ref.current.contains(event.target) && callback) {
            callback();
        }
    };
    useEffect(function () {
        document.addEventListener('click', handleClick);
        return function () {
            document.removeEventListener('click', handleClick);
        };
    });
};
//# sourceMappingURL=useOutsideClick.js.map